import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import HTML from 'molecules/HTML';

import './HeaderClone.scss';

/**
 * Header clone.
 */
const propTypes = {

}
const HeaderClone = p => {

  const className = classnames(
    'HeaderClone',
    p.className
  );

  React.useEffect( () => {

    // Menu toggles.
    const navTrigger = document.querySelector( '.js-nav-trigger' );
    if( navTrigger ) {
      navTrigger.addEventListener( 'click', () => {
        document.body.classList.toggle( 'is-showing-nav' );
      } );
    }
    document.addEventListener( 'click', e => {

      if( document.body.classList.contains( 'is-showing-nav' ) ) {
        return;
      }

      const el = e.target;

    } );

    // Submenu toggles.
    const subTriggers = document.querySelectorAll( '.js-nav-parent > a' );
    if( subTriggers ) {
      for( let t of subTriggers ) {

        t.addEventListener( 'click', e => {
          e.preventDefault();

          const parent = e.target.closest( '.js-nav-parent' );

          if(
            !! parent &&
            parent.style.content !== 'no-click' &&
            parent.style.content !== '"no-click"'
          ) {
            parent.classList.toggle( 'is-showing-submenu' );
          }

        } );

      }
    }

    //Service menu toggle.
    const serviceTriggers = document.querySelectorAll( '.js-service-link' );
    if( serviceTriggers ) {
      for( let el of serviceTriggers ) {
        el.addEventListener( 'click', e => {
          e.preventDefault();

          const button = e.target.closest( '.js-service-link' );
          if( ! button ) {
            return;
          }

          if(
            button.style.content === 'no-click' ||
            button.style.content === '"no-click"'
          ) {
            return;
          }

          //console.log( button.nextSibling );

          const thisMenu = button.nextElementSibling;
          const allMenus = document.querySelectorAll( '.l-header__servmenu' );

          // Make sure active class is removed from other buttons and menus.
          for( let el of serviceTriggers ) {
            if( el == button ) {
              continue;
            }
            el.classList.remove( 'is-showing' )
          }
          for( let el of allMenus ) {
            if( el == thisMenu ) {
              continue;
            }
            el.classList.remove( 'is-showing' );
          }

          // Toggle this button and menus.
          button.classList.toggle( 'is-showing' );
          thisMenu.classList.toggle( 'is-showing' );




        } );

      }
    }

    // Service submenu toggle.
    const serviceSubs = document.querySelectorAll( '.js-nav-list-trigger' );
    for( let el of serviceSubs ) {

      el.addEventListener( 'click', e => {
        e.preventDefault();

        const button = e.target.closest( '.js-nav-list-trigger' );
        const targetID = button.getAttribute( 'href' ).replace( '#', '' );
        const targetMenu = document.getElementById( targetID );
        const otherMenus = document.querySelectorAll( `.l-header__servmenu-list:not(${targetID})` );

        // Remove active classes from other menus.
        for( let otherEl of serviceSubs ) {
          if( otherEl == el ) {
            continue;
          }
          otherEl.classList.remove( 'is-open' );
        }
        for( let otherMenu of otherMenus ) {
          if( otherMenu == targetMenu ) {
            continue;
          }
          otherMenu.classList.remove( 'is-open' );
        }

        button.classList.toggle( 'is-open' );
        targetMenu.classList.toggle( 'is-open' );


      } );
    }


  }, [] );

  return(

    <>

      <div
      dangerouslySetInnerHTML={ { __html: `

        <header id="masthead" class="l-header js-sticky-header" role="banner" itemscope="" itemtype="http://schema.org/WPHeader">


          <div class="inner">

            <a href="https://www.dartdrones.com" class="l-header__logo">
              <img src="https://www.dartdrones.com/wp-content/uploads/2017/11/dartdrones-logo-small-2017.png" alt="DARTdrones"/>
            </a>

            <div class="l-header__services clearfix">

              <div class="l-header__services-type l-header__services-type--indvls">

                <a href="#in-person" class="l-header__services-link js-service-link">
                  <span class="prehding">For Individuals</span>
                  <span class="hding">Drone Courses</span>
                </a>

                <nav class="l-header__servmenu individuals clearfix">
                  <div class="row">

                    <div class="columns large-4">
                      <a
                      href="#in-person-menu"
                      class="l-header__servmenu-hding js-nav-list-trigger"
                      >
                        In-Person Courses
                      </a>
                      <ul id="in-person-menu" class="l-header__servmenu-list clean-list">

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/drone-training/professional-wings-program"
                          class="link"
                          >
                            <span class="most-popular show-for-large">** Most Popular! **</span>
                            Professional Wings Program
                            <i class="icon ddicon-long-arrow"></i>

                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/drone-training/flying-class"
                          class="link"
                          >
                            Basic Flight Training
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/part-107-commercial-drone-license"
                          class="link"
                          >
                            Part 107 Test Prep
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/trusted-operator-program-level-2-certification/"
                          class="link"
                          >
                            TOP™ Level 2 Certification
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/aerial-drone-inspections/"
                          class="link"
                          >
                            Aerial Inspections Workshop
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/drone-mapping/"
                          class="link"
                          >
                            Aerial Mapping & Modeling Workshop
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                      </ul>
                    </div>

                    <div class="columns large-4">
                      <a
                      href="#online-menu"
                      class="l-header__servmenu-hding js-nav-list-trigger"
                      >
                        Online Courses
                      </a>
                      <ul id="online-menu" class="l-header__servmenu-list clean-list">

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/courses/online-part-107-test-prep"
                          class="link"
                          >
                            Online Part 107 Test Prep
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>


                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/courses/online-aerial-photography"
                          class="link"
                          >
                            Aerial Photography
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/night-flight-drone-training/"
                          class="link"
                          >
                            Night Operations
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/disaster-response-drone-training/"
                          class="link"
                          >
                            Disaster Response
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/online-courses/drones-for-beginners/"
                          class="link"
                          >
                            Drone for Beginners
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/drone-business-part-107/",
                          class="link"
                          >
                            Starting a Drone Business
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/real-world-flight-planning-execution-program"
                          class="link"
                          >
                            Real World Flight Planning & Execution
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/trusted-operator-program-level-1-certification/"
                          class="link"
                          >
                            TOP™ Level 1 Remote Pilot Certification
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>
                      </ul>
                    </div>


                    <div class="columns large-4">
                      <a
                      href="#virtual-menu"
                      class="l-header__servmenu-hding js-nav-list-trigger"
                      >
                        Virtual Workshops
                      </a>
                      <ul id="virtual-menu" class="l-header__servmenu-list clean-list">

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/workshops/aerial-drone-mapping-virtual-training"
                          class="link"
                          >
                            Aerial Mapping & Modeling
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                        <li class="l-header__servmenu-item">
                          <a
                          href="https://www.dartdrones.com/workshops/aerial-inspections-virtual-training"
                          class="link"
                          >
                            Aerial Inspections
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>

                      </ul>
                    </div>

                  </div>


                  <!--<div class="l-header__servmenu-pro">

                    <a href="#bundle-nav" class="l-header__servmenu-hding js-nav-list-trigger">
                      Professional Drone Pilot Package
                    </a>
                    <ul id="bundle-nav" class="clean-list l-header__servmenu-list">
                      <li class="l-header__servmenu-item package-link">
                        <div class="show-for-large" style="margin-bottom: 1.5rem"><p class="p1">3 classes in 1 – the ultimate package to become a certified pilot.</p>
                        </div>
                        <a href="https://www.dartdrones.com/drone-pilot-training-package/" class="link">
                          <span class="label hide-for-large" style="margin-right: 0.25rem">All Below Courses Included </span>
                          <span class="btn btn--md--green">Learn More</span>
                        </a>
                      </li>
                      <ul class="submenu clean-list">
                        <li class="show-for-large submenu-hding">Package Includes:</li>
                        <li class="l-header__servmenu-item">
                          <a href="https://www.dartdrones.com/drone-training/flying-class/" class="link">
                            <span class="label">In-Person Basic Flight Training</span>
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>
                        <li class="l-header__servmenu-item">
                          <a href="https://www.dartdrones.com/part-107-commercial-drone-license/" class="link">
                            <span class="label">In-Person Part 107 Test Prep</span>
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>
                        <li class="l-header__servmenu-item">
                          <a href="https://www.dartdrones.com/real-world-flight-planning-execution-program/" class="link">
                            <span class="label">Real-World Flight Planning &amp; Execution</span>
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>
                        <li class="l-header__servmenu-item">
                          <a href="https://www.dartdrones.com/wings-program/" class="link">
                            <span class="label">Earn Your DARTdrones Wings</span>
                            <i class="icon ddicon-long-arrow"></i>
                          </a>
                        </li>
                      </ul>
                    </ul>
                  </div>

                  <div class="l-header__servmenu-column l-header__servmenu-column--left">

                    <a href="#in-person" class="l-header__servmenu-hding js-nav-list-trigger">Additional In-Person Courses</a>
                    <ul id="in-person" class="clean-list l-header__servmenu-list online ">
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/drone-mapping/" class="link">
                          <span class="text">Aerial Mapping &amp; Modeling Workshop</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/aerial-drone-inspections/" class="link">
                          <span class="text">Aerial Drone Inspections Workshop</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/trusted-operator-program-level-2-certification/" class="link">
                          <span class="text">Trusted Operator Program (TOP) Level 2</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div class="l-header__servmenu-column l-header__servmenu-column--right right">

                    <a href="#online-nav" class="l-header__servmenu-hding js-nav-list-trigger">Additional Online Courses</a>
                    <ul id="online-nav" class="clean-list l-header__servmenu-list workshops">
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/part-107-online/" class="link">
                          <span class="text">Online Part 107 Test Prep</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/night-flight-drone-training/" class="link">
                          <span class="text">Night Operations</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/disaster-response-drone-training/" class="link">
                          <span class="text">Disaster Response</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/online-courses/drones-for-beginners/" class="link">
                          <span class="text">Drones for Beginners</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/drone-business-part-107/" class="link">
                          <span class="text">Starting a Drone Business</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/aerial-photography/" class="link">
                          <span class="text">Aerial Photography</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                -->
                </nav>
              </div>

              <div class="l-header__services-type l-header__services-type--group">
                <a href="#groups" class="l-header__services-link js-service-link">
                  <span class="prehding">For Organizations</span>
                  <span class="hding">Customized Solutions</span>
                </a>

                <nav class="l-header__servmenu organizations clearfix">

                  <div class="l-header__servmenu-dropdown--left l-header__servmenu-column l-header__servmenu-column--left">

                    <a href="#header-programs" class="l-header__servmenu-hding js-nav-list-trigger">Program Implementation</a>
                    <ul id="header-programs" class="clean-list l-header__servmenu-list">
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/custom-on-site-uav-training-for-organizations/" class="link">
                          <span class="label">On-Site Custom Training</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/drone-consulting-services/" class="link">
                          <span class="label">Consulting</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/pilothub/" class="link">
                          <span class="label">PilotHub</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/auvsi-trusted-operator-program/" class="link">
                          <span class="label">AUVSI Trusted Operator Program™</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div class="l-header__servmenu-column l-header__servmenu-column--right industries">

                    <a href="#industry-nav" class="l-header__servmenu-hding js-nav-list-trigger">Choose Your Industry</a>

                    <ul id="industry-nav" class="clean-list double-col-list l-header__servmenu-list">
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/drone-pilot-training-recreation/" class="link">
                          <span class="label">Recreational</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/custom-government-drone-training/" class="link">
                          <span class="label">Government Agencies</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/uav-mapping-modeling/" class="link">
                          <span class="label">UAV Mapping and Modeling</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/drone-journalism-training/" class="link">
                          <span class="label">Broadcast Media</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/construction-drone-training/" class="link">
                          <span class="label">Construction and Engineering</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/industrial-inspections-drone-training/" class="link">
                          <span class="label">Industrial Inspections</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/starting-a-drone-business/" class="link">
                          <span class="label">Starting a Drone Business</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/fire-department-drone-training/" class="link">
                          <span class="label">Fire Departments</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/law-enforcement-uav-training/" class="link">
                          <span class="label">Police Departments</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/dronel-photography-training/" class="link">
                          <span class="label">Aerial Photography</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/drone-real-estate/" class="link">
                          <span class="label">Real Estate</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/drone-roof-inspection/" class="link">
                          <span class="label">Roof and Home Inspections</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                      <li class="l-header__servmenu-item">
                        <a href="https://www.dartdrones.com/security-drone-uav-training/" class="link">
                          <span class="label">Aerial Security</span>
                          <i class="icon ddicon-long-arrow"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>

            <nav class="l-header__nav ">

              <ul class="clean-list l-header__nav-menu">
                <li class="l-header__nav-top-level has-submenu js-nav-parent">
                  <a href="">Pilot Credentialing</a>

                  <ul class="l-header__nav-submenu clean-list">
                    <li class="l-header__nav-second-level">
                      <a href="https://www.dartdrones.com/wings-program/">DARTdrones Wings Program</a>
                    </li>
                    <li class="l-header__nav-second-level">
                      <a href="https://www.dartdrones.com/auvsi-trusted-operator-program/">AUVSI Trusted Operator Program™</a>
                    </li>
                    <li class="l-header__nav-second-level">
                      <a href="https://www.dartdrones.com/services/">Drone Services</a>
                    </li>
                  </ul>
                </li>
                <li class="l-header__nav-top-level has-submenu js-nav-parent">
                  <a href="">Resources</a>

                  <ul class="l-header__nav-submenu clean-list">
                    <li class="l-header__nav-second-level">
                      <a href="https://www.dartdrones.com/blog/">Blog</a>
                    </li>
                    <li class="l-header__nav-second-level">
                      <a href="https://www.dartdrones.com/drones-for-railways/">Drones for Railways</a>
                    </li>
                    <li class="l-header__nav-second-level">
                      <a href="https://www.dartdrones.com/drone-mapping-and-surveying/">Drones for Mapping and Surveying</a>
                    </li>
                    <li class="l-header__nav-second-level">
                      <a href="https://www.dartdrones.com/security-drones/">Drones for Security</a>
                    </li>
                    <li class="l-header__nav-second-level">
                      <a href="https://www.dartdrones.com/drones-for-real-estate/">Drones for Real Estate</a>
                    </li>
                    <li class="l-header__nav-second-level">
                      <a href="https://www.dartdrones.com/police-fire-drone-program-ebooks/">Public Safety E-Books</a>
                    </li>
                  </ul>
                </li>
                <li class="l-header__nav-top-level ">
                  <a href="https://www.dartdrones.com/about-us/">About</a>
                </li>
                <li class="l-header__nav-top-level ">
                  <a href="https://www.dartdrones.com/reviews/">Reviews</a>
                </li>
                <li class="l-header__nav-top-level ">
                  <a href="https://www.dartdrones.com/contact-us/">Contact Us</a>
                </li>

                <li class="l-header__nav-top-level cart">
                  <a href="https://www.dartdrones.com/cart/">
                    <span class="text">Cart</span>
                    <i class="ddicon-cart"></i>
                  </a>
                </li>
              </ul>

              <div class="l-header__nav-secondary clearfix">

                <a href="https://dartdrones.litmos.com" class="login">
                  <i class="icon ddicon-avatar"></i>
                  <span class="text">Online Login</span>
                </a>

                <a href="tel:1.800.264.3907" class="phone">
                  <i class="icon ddicon-phone"></i>
                  <span class="text">+1.800.264.3907</span>
                </a>

                <span class="shark-tank">As seen on <strong>ABC's 'Shark Tank'!</strong></span>
              </div>
            </nav>
          </div>
          <style>
          .l-covid-banner {
            text-align: center;
            background: #b8d4e3;
          }
          .l-covid-banner p {
            padding: 0.75rem 1rem;
            margin-bottom: 0;
            font-weight: 600;
            font-size: 1.15rem;
          }
          .l-covid-banner a {
            color: black;
            font-weight: 700;
            text-decoration: underline;
          }
          </style>
        </header>

        <div class="l-covid-banner">
          <p class="row">
            Check out our COVID-19 policy changes and in-person class requirements: <a href="https://www.dartdrones.com/our-covid-policies/" target="_blank">Learn more</a>.</p>
          </div>

      ` } } />

    </>

  )

};
HeaderClone.propTypes = propTypes;

export default HeaderClone;
